import { useEffect } from "react";
import { useSelector } from "react-redux";
import { applyPartnerPwaBranding } from "../utils/applyPartnerPwaBranding";

function usePartnerPwaBranding() {
  const partner = useSelector((state) => state?.global?.partner);

  useEffect(() => {
    if (!partner?.name || !partner?.mediaLink) return;
    applyPartnerPwaBranding({
      name: partner.name,
      mediaLink: partner.mediaLink,
    }).catch(() => {});
  }, [partner?.name, partner?.mediaLink]);
}

export default usePartnerPwaBranding;
